module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_novel1.9562e.png";